import { DropdownItem } from '@/common/components';
import { TFunction } from 'i18next';
import { RaceOptionId } from '../../constants/races';

export const getRaceOptions = (t: TFunction): DropdownItem[] => {
  return [
    {
      id: RaceOptionId.AMERICAN_INDIAN_ALASKA_NATIVE,
      label: t(`form.race_option.${RaceOptionId.AMERICAN_INDIAN_ALASKA_NATIVE}`),
    },
    {
      id: RaceOptionId.ASIAN,
      label: t(`form.race_option.${RaceOptionId.ASIAN}`),
    },
    {
      id: RaceOptionId.BLACK_AFRICAN_AMERICAN,
      label: t(`form.race_option.${RaceOptionId.BLACK_AFRICAN_AMERICAN}`),
    },
    {
      id: RaceOptionId.NATIVE_HAWAIIAN_OTHER_PACIFIC_ISLANDER,
      label: t(`form.race_option.${RaceOptionId.NATIVE_HAWAIIAN_OTHER_PACIFIC_ISLANDER}`),
    },
    {
      id: RaceOptionId.OTHER_RACE,
      label: t(`form.race_option.${RaceOptionId.OTHER_RACE}`),
    },
    {
      id: RaceOptionId.WHITE,
      label: t(`form.race_option.${RaceOptionId.WHITE}`),
    },
    {
      id: RaceOptionId.UNKNOWN,
      label: t(`form.race_option.${RaceOptionId.UNKNOWN}`),
    },
    {
      id: RaceOptionId.PREFER_NOT_ANSWER,
      label: t(`form.race_option.${RaceOptionId.PREFER_NOT_ANSWER}`),
    },
  ];
};
